import { createStore } from 'zustand';
import { combine } from 'zustand/middleware';

export enum PackType {
  NIGHT_STAY = 'NIGHT_STAY',
  DAYTIME = 'DAYTIME',
}

type InventoryStoreValuesType = {
  packType: PackType;
  selectedPackId: number | undefined;
};

type InventoryStoreMutationType = {
  setPackType: (value: PackType) => void;
  setSelectedPackId: (id: number | undefined) => void;
};

const initialValues: InventoryStoreValuesType = {
  packType: PackType.NIGHT_STAY,
  selectedPackId: undefined,
};

export const packagesStore = createStore(
  /**
   * Uncomment the following line to enable debugging with Redux DevTools
   * https://github.com/pmndrs/zustand?tab=readme-ov-file#redux-devtools
   * https://chromewebstore.google.com/detail/redux-devtools/lmhkpmbekcpmknklioeibfkpmmfibljd?hl=en
   */
  // devtools(
  combine<InventoryStoreValuesType, InventoryStoreMutationType>(
    initialValues,
    (set) => ({
      setPackType: (value: PackType) => set({ packType: value }),
      setSelectedPackId: (id: number | undefined) =>
        set({ selectedPackId: id }),
    })
  )
);
